import Layout from '@/layout'
const Travel = {
    component: Layout,
    path: '/tourismculture',
    name: '旅游文化设置',
    redirect:'tourismculture',
    meta: {
        title: '旅游文化设置',
        icon: ''
    },
    children: [
          {
            path: '/tourismculture/homestaymanag',
            name: 'homestaymanag',
            meta: { title: "民宿管理" },
            component: () => import('../views/tourismculture/homestaymanag.vue')
    
          },
          {
            path: '/tourismculture/popularattra',
            name: 'popularattra',
            meta: { bread: [{ name: "旅游文化管理", jump: '' }, { name: "热门景点列表", jump: '' }] },
            component: () => import('../views/tourismculture/popularattra.vue')
            
          },
          {
            path: '/tourismculture/popularattractions/list',
            name: 'listpopularattractions',
            meta: { bread: [{ name: "旅游文化管理", jump: '' }, { name: "新建热门景点", jump: '' }] },
            component: () => import('../views/tourismculture/popularattractions/list.vue')
          },
          {
            path: '/tourismculture/recommend',
            name: 'recommend',
            meta: { bread: [{ name: "旅游文化管理", jump: '' }, { name: "推荐路线列表", jump: '' }] },
            component: () => import('../views/tourismculture/recommend.vue')
            
          },
          {
            path: '/tourismculture/recommendS/list',
            name: 'listrecommendS',
            meta: { bread: [{ name: "旅游文化管理", jump: '' }, { name: "新建推荐路线", jump: '' }] },
            component: () => import('../views/tourismculture/recommendS/list.vue')
          },
          {
            path: '/tourismculture/playingwith',
            name: 'playingwith',
            meta: { bread: [{ name: "旅游文化管理", jump: '' }, { name: "玩什么文章列表", jump: '' }] },
            component: () => import('../views/tourismculture/playingwith.vue')
            
          },
          {
            path: '/tourismculture/playingwithS/list',
            name: 'listplayingwithS',
            meta: { bread: [{ name: "旅游文化管理", jump: '' }, { name: "新建文章", jump: '' }] },
            component: () => import('../views/tourismculture/playingwithS/list.vue')
          }
        
    ]
}
export default Travel